<template>
  <div>
    <article
      v-for="location in locations"
      :key="location._id"
      @mouseenter="highlightLocation(location)"
      @mouseleave="highlightLocation(false)"
    >
      <div class="label">
        <LocationLabel :location="location" :hover="hover" />
      </div>
      <div class="content">
        <LocationInfo :location="location" v-bind="params || {}" />
        <div><slot v-bind:location="location" /></div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import LocationInfo from '@/components/LocationInfo.vue'
import LocationLabel from '@/components/LocationLabel'

export default {
  name: 'LocationList',
  props: ['locations', 'params', 'hover'],
  components: { LocationInfo, LocationLabel },
  methods: {
    ...mapActions(['highlightLocation'])
  }
}
</script>

<style scoped>
article {
  display: flex;
  padding: 2em 0;
}
article:first-child {
  padding-top: 0;
}
article:last-child {
  padding-bottom: 0;
}
.label {
  position: sticky;
  top: var(--header-height);
  padding-left: 0;
  height: 0;
  flex: 0 0 var(--content-indent);
}
.content {
  flex: 1 0 50%;
  padding-top: 0.05rem;
  > div:last-child {
    padding-top: 2.25em;
    &:empty {
      display: none;
    }
  }
}
@media only print {
  article {
    display: inline-block;
    width: 100%;
    page-break-inside: avoid;
  }
  .label {
    position: static;
    height: auto;
    margin-bottom: 0.4em;
  }
}
</style>
